import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import { GiftItemBrand, GiftItemBrandList } from './giftItemBrand.interface';

// GiftItemBrand 목록
export const giftItemBrandListStatusAtom = atom<QueryStatus>({
  key: 'giftItemBrandListStatusAtom',
  default: 'idle',
});

export const giftItemBrandListDataAtom = atom<GiftItemBrandList>({
  key: 'giftItemBrandListDataAtom',
  default: [],
});

// GiftItemBrand 단건
export const giftItemBrandStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftItemBrandStatusAtomFamily',
  default: 'idle',
});

export const giftItemBrandDataAtomFamily = atomFamily<GiftItemBrand | null, string>({
  key: 'giftItemBrandDataAtomFamily',
  default: null,
});
